import React, { useEffect, useState } from "react";
import api from "../../../Services/api";
import { useHistory } from "react-router-dom";
import SidebarMenu from "../../../Components/SidebarMenu";
import { Page } from "../../SignedOut/Cadastro/styles";
import { PageTitle } from "../CadastrarMedico/styles";
import { ErrorMsg, ErrorBtn } from "../Pacientes/styles";
import { BsEyeFill, BsArrowRight, BsArrowLeft } from "react-icons/bs";
import ReactLoading from "react-loading";
import { Background, PageContainerDiv, RightDiv } from "../Perfil/styles";
import DataTable from 'react-data-table-component';
import CreatableSelect from "react-select/creatable";
import ExportCSVButton from "../../../Components/ExportCSVButton";

export default function Prestadores() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [errorRepositories, setErrorRepositories] = useState(null);
  const [repositoriesData, setRepositoriesData] = useState([]);
  const [activeTab, setActiveTab] = useState('ativos'); // 'ativos' | 'suspensos'
  const [suspensosData, setSuspensosData] = useState([]);
  const [loadingSuspensos, setLoadingSuspensos] = useState(false);
  const [infoPagina, setInfoPagina] = useState(
    {
      has_next: false,
      has_previous: false,
      per_page: 0,
      page: 1,
      total: 0,
    }
  );
  const [infoPaginaSuspensos, setInfoPaginaSuspensos] = useState(
    {
      has_next: false,
      has_previous: false,
      per_page: 0,
      page: 1,
      total: 0,
    }
  );
  const [quantidadeExibidaNaTabela, setQuantidadeExibidaNaTabela] = useState({ label: "20", value: 20 });
  const [searchText, setSearchText] = useState("");

  // Filtrar dados com base no texto de busca
  const getFilteredData = (data) => {
    const searchLower = searchText.toLowerCase();
    return data.filter((row) => {
      const nome = row.usuario?.NO_primeiro_nome + " " + (row.usuario?.NO_ultimo_nome || row.usuario?.DS_razao_social || "");
      const crm = row.CD_numero_registro_profissional?.toLowerCase() || "";
      return nome.toLowerCase().includes(searchLower) || crm.includes(searchLower);
    });
  };

  const dropdownCustomStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "10vw",
      minHeight: "30px",
      borderRadius: "10px",
      backgroundColor: "#fafafa",
      fontSize: "18px",
      color: "black",
      border: "1px solid #d5d5d5",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "black",
    }),
  };

  const opcoesQuantidadeExibidos = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "15", value: 15 },
    { label: "20", value: 20 }
  ];

  const colunasTabela = [
    {
      name: 'Nome',
      selector: row => {
        if (!row.usuario.NO_ultimo_nome) {
          return row.usuario.NO_primeiro_nome + " " + (row.usuario.DS_razao_social || "");
        }
        return row.usuario.NO_primeiro_nome + " " + row.usuario.NO_ultimo_nome;
      },
      sortable: true,
    },
    {
      name: 'CRM',
      selector: row => row.CD_numero_registro_profissional,
      sortable: true,
    },
    {
      name: '',
      maxWidth: '40px',
      selector: row =>
        <BsEyeFill
          className="cursor-pointer"
          onClick={() => {
            history.push(`/prestadores/${row.usuario.id_usuario}`);
          }} size={20} color="#7A99E3"
        />,
    },
  ];

  const fetchRepositoriesData = async (proximaPagina = false, ultimaPagina = false, quantidadeParaExibir = quantidadeExibidaNaTabela) => {
    setLoading(true);
    setErrorRepositories(null);

    try {
      let modifier = 0;
      if (proximaPagina) {
        modifier = 1;
      }
      if (ultimaPagina) {
        modifier = -1;
      }
      const response = await api.get(`/medicos/listar?page=${infoPagina.page + modifier}&per_page=${quantidadeParaExibir.value}`);
      console.log("resposta ativos", response);
      const repositories = response.data.medicos;
      setRepositoriesData(repositories);
      setInfoPagina(
        {
          has_next: response.data.has_next,
          has_previous: response.data.has_previous,
          per_page: response.data.per_page,
          page: response.data.page,
          total: response.data.total,
        }
      );
    } catch (error) {
      setErrorRepositories("Ocorreu um erro ao carregar a página");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSuspensosData = async (proximaPagina = false, ultimaPagina = false, quantidadeParaExibir = quantidadeExibidaNaTabela) => {
    setLoadingSuspensos(true);
    setErrorRepositories(null);

    try {
      let modifier = 0;
      if (proximaPagina) {
        modifier = 1;
      }
      if (ultimaPagina) {
        modifier = -1;
      }
      const response = await api.get(`/medicos/listar_suspensos?page=${infoPaginaSuspensos.page + modifier}&per_page=${quantidadeParaExibir.value}`);
      console.log("resposta suspensos", response);
      const repositories = response.data.medicos;
      setSuspensosData(repositories);
      setInfoPaginaSuspensos(
        {
          has_next: response.data.has_next,
          has_previous: response.data.has_previous,
          per_page: response.data.per_page,
          page: response.data.page,
          total: response.data.total,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingSuspensos(false);
    }
  };

  useEffect(() => {
    fetchRepositoriesData();
    fetchSuspensosData();
  }, []);

  const proximaPagina = async (proxima) => {
    if (activeTab === 'ativos') {
      if (proxima) {
        if (infoPagina.has_next) {
          fetchRepositoriesData(true, false);
        }
      } else {
        if (infoPagina.has_previous) {
          fetchRepositoriesData(false, true);
        }
      }
    } else {
      if (proxima) {
        if (infoPaginaSuspensos.has_next) {
          fetchSuspensosData(true, false);
        }
      } else {
        if (infoPaginaSuspensos.has_previous) {
          fetchSuspensosData(false, true);
        }
      }
    }
  };

  const mudarQuantidadeExibida = async (quantidade) => {
    setQuantidadeExibidaNaTabela(quantidade);
    if (activeTab === 'ativos') {
      fetchRepositoriesData(false, false, quantidade);
    } else {
      fetchSuspensosData(false, false, quantidade);
    }
  }

  function refresh() {
    window.location.reload();
  }

  const currentData = activeTab === 'ativos' ? repositoriesData : suspensosData;
  const filteredData = getFilteredData(currentData);
  const currentInfo = activeTab === 'ativos' ? infoPagina : infoPaginaSuspensos;
  const currentLoading = activeTab === 'ativos' ? loading : loadingSuspensos;

  if (errorRepositories) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainerDiv>
          <Background>
            <RightDiv>
              <PageTitle>Prestadores</PageTitle>
              <ErrorMsg>{errorRepositories}</ErrorMsg>
              <ErrorBtn onClick={(event) => refresh(event)}>
                Tentar novamente
              </ErrorBtn>
            </RightDiv>
          </Background>
        </PageContainerDiv>
      </Page>
    );
  }

  return (
    <Page>
      <SidebarMenu />

      <PageContainerDiv>
        <Background>
          <RightDiv>
            <PageTitle>Prestadores</PageTitle>

            {/* Tabs */}
            <div className="flex flex-row w-full mb-4 gap-2">
              <button
                onClick={() => setActiveTab('ativos')}
                className={`px-6 py-2 rounded-lg font-bold transition-all ${activeTab === 'ativos'
                  ? 'bg-[#EFCA04] text-black'
                  : 'bg-gray-600 text-white hover:bg-gray-500'
                  }`}
              >
                Ativos ({infoPagina.total || 0})
              </button>
              <button
                onClick={() => setActiveTab('suspensos')}
                className={`px-6 py-2 rounded-lg font-bold transition-all ${activeTab === 'suspensos'
                  ? 'bg-red-500 text-white'
                  : 'bg-gray-600 text-white hover:bg-gray-500'
                  }`}
              >
                Bloqueados ({infoPaginaSuspensos.total || 0})
              </button>
            </div>

            <div className="flex flex-col w-full space-y-2">
              <div className="flex flex-row w-full justify-between items-center">
                <p className="text-white font-bold pr-2">Exibir:</p>
                <CreatableSelect
                  options={opcoesQuantidadeExibidos}
                  required
                  value={quantidadeExibidaNaTabela}
                  onChange={(e) => {
                    e.value > 20 ? mudarQuantidadeExibida(opcoesQuantidadeExibidos.at(-1)) : mudarQuantidadeExibida(e);
                  }}
                  styles={dropdownCustomStyles}
                  placeholder={"Selecione a quantidade que será exibida na tabela"}
                />
                <ExportCSVButton exportData={filteredData} />
              </div>
              {/* Campo de busca */}
              <div className="flex flex-row w-full">
                <input
                  type="text"
                  placeholder="Buscar por nome ou CRM..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#EFCA04]"
                />
              </div>

              {currentLoading ? (
                <div className="flex justify-center py-8">
                  <ReactLoading
                    type="spin"
                    color="#067187"
                    height={"30px"}
                    width={"30px"}
                  />
                </div>
              ) : (
                <>
                  <div className="w-full max-h-96 overflow-x-auto overflow-y-visible">
                    {filteredData.length === 0 ? (
                      <div className="flex justify-center py-8 text-white">
                        {searchText
                          ? 'Nenhum prestador encontrado com essa busca'
                          : activeTab === 'ativos'
                            ? 'Nenhum prestador ativo encontrado'
                            : 'Nenhum prestador bloqueado encontrado'}
                      </div>
                    ) : (
                      <DataTable
                        columns={colunasTabela}
                        data={filteredData}
                        responsive
                        customStyles={{
                          headCells: {
                            style: {
                              backgroundColor: activeTab === 'ativos' ? "#EFCA04" : "#EF4444",
                              fontSize: "16px",
                            },
                          },
                        }}
                      />
                    )}
                  </div>

                  <div className="flex flex-row w-full justify-between items-center">
                    <BsArrowLeft
                      className={currentInfo.has_previous ? "cursor-pointer" : "cursor-not-allowed"}
                      onClick={() => proximaPagina(false)}
                      size={50}
                      color={currentInfo.has_previous ? (activeTab === 'ativos' ? "#EFCA04" : "#EF4444") : "#ebe0a7"} />
                    <p className={activeTab === 'ativos' ? "text-[#EFCA04]" : "text-red-500"}>
                      {currentInfo.page + "/" + Math.max(1, Math.ceil(currentInfo.total / currentInfo.per_page))}
                    </p>
                    <BsArrowRight
                      className={currentInfo.has_next ? "cursor-pointer" : "cursor-not-allowed"}
                      onClick={() => proximaPagina(true)}
                      size={50}
                      color={currentInfo.has_next ? (activeTab === 'ativos' ? "#EFCA04" : "#EF4444") : "#ebe0a7"} />
                  </div>
                </>
              )}
            </div>
          </RightDiv>
        </Background>
      </PageContainerDiv>

    </Page>
  );
}
